import React from 'react'

const ExecutedJobs = () => {
  return (
    <div>ExecutedJobs</div>
  )
}

export default ExecutedJobs